import React from 'react';

import { Article } from '../../elements/Article/Article';

import "./About.scss";

export const About = ()=>{
    return (
        <section className="About">
            <Article className="block wall" src="web-about" level={0}/>
        </section>
    )
}

export default About;
